<template>
  <div>
    <div
      v-if="!copiedLink"
      tabindex="0"
      class="copy-to-clipboard-button"
      @click="copyLink()"
      @keyup.enter="copyLink()"
    >
      <slot name="click-to-copy" />
    </div>
    <div v-if="copiedLink">
      <slot name="result" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'copy-to-clipboard',
  props: {
    text: String
  },
  data() {
    return {
      copiedLink: false
    }
  },
  methods: {
    copyLink() {
      const textToCopy = decodeURIComponent(this.text)

      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.copiedLink = true
        })
        .catch(err => {
          console.error('Erro ao copiar texto:', err)
        })
    }

  }
}
</script>
